import {
  customInstance
} from "./chunk-PXAHF6KP.js";

// generated/search-bff/controllers/auto-suggestion/auto-suggestion.ts
var commonSuggest = (params, options) => {
  return customInstance(
    {
      url: `/api/v2/autosuggestion/suggest`,
      method: "GET",
      params
    },
    options
  );
};
var getPlaceDetailsForPropertyEngine = (params, options) => {
  return customInstance(
    {
      url: `/api/v2/autosuggestion/property-engine/details`,
      method: "GET",
      params
    },
    options
  );
};
var commonPropertySuggest = (params, options) => {
  return customInstance(
    {
      url: `/api/v2/autosuggestion/listing/suggest`,
      method: "GET",
      params
    },
    options
  );
};
var getPlaceDetailsV2 = (params, options) => {
  return customInstance(
    {
      url: `/api/v2/autosuggestion/details`,
      method: "GET",
      params
    },
    options
  );
};

export {
  commonSuggest,
  getPlaceDetailsForPropertyEngine,
  commonPropertySuggest,
  getPlaceDetailsV2
};
